// extracted by mini-css-extract-plugin
export default {"Navigation":"TablePagination_Navigation__66Uw9"};